/**
 * Created by hp on 2017/6/9.
 */
import React, {Component} from "react";
import {Mask} from "react-weui";

import "../../styles/lecture/LectureDialog.css";

export default class LectureDialog extends Component {
    render() {
        const {show, title, children, redirectUrl, onClick, closeText, onRequestClose} = this.props;
        return (
            <div className="lecture-dialog" style={{display: show ? 'block' : 'none'}}>
                <Mask onClick={onRequestClose}/>
                <div className="dialog-template">
                    <div className="dialog-content">
                        <p className="text-center"> {title} </p>
                        {children}
                    </div>
                    <div className="dialog-btn">
                        <a className="dialog-close" href={redirectUrl} onClick={onClick} style={{fontSize: "16px"}}>
                            {closeText ? closeText : "关闭"}
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/lecture/LectureDialog.js